export class MPARequestDetail {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "request",
            "baseName": "request",
            "type": "MPARequest",
            "format": ""
        },
        {
            "name": "reviews",
            "baseName": "reviews",
            "type": "Array<MPAReview>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPARequestDetail.attributeTypeMap;
    }
    constructor() {
    }
}
